<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <van-tabs v-model="active" @change="handleClick" :ellipsis="false">
      <!-- <van-tab title="驳回" :badge="contCount.bhCount != 0?contCount.bhCount:''"></van-tab>
      <van-tab title="用章" :badge="contCount.yzCount != 0?contCount.yzCount:''"></van-tab>
      <van-tab title="垫款" :badge="contCount.dkCount != 0?contCount.dkCount:''"></van-tab>
      <van-tab title="用印" :badge="contCount.yyCount != 0?contCount.yyCount:''"></van-tab> -->
      <van-tab title="签署归档中" :badge="contCount.qsCount != 0?contCount.qsCount:''"></van-tab>
      <van-tab title="签署归档" :badge="contCount.gdCount != 0?contCount.gdCount:''"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <list-item @todetail="toDetails" :listData="list" />
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- <dialog-apply :show='add_show' :isAdd='true' @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose' ></dialog-apply> -->
  </div>
</template>

<script>
import moment from 'moment'
import newContract from '@/api/cont/newContract'
import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchPop from '../components/contract/SearchPop.vue'
// import DialogApply from '../components/DialogApply.vue'
import ListItem from '../components/contract/ListContractItem.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Tab, Tabs } from 'vant'
export default {
  name: 'approve',
  components: {
    SearchComponent,
    SearchPop,
    EmptyComponent,
    TotalComponent,
    ListItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      deptTreeList: [],
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      custList: [],
      options: {},
      contCount: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractNum: '',
        contractName: '',
        serviceTypeId: '',
        templateType: null,
        payType: null,
        contractStatus: 6,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  async created() {
    // 合同模板
    await getDicts('template_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    // 框架类型
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    await this.handleList()
    await this.getContCount()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '添加收款'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.getContCount({ contractName: data })
      this.queryParams.contractName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      this.getContCount(data)
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      // if (this.active == 0) {
      //   this.$router.push({
      //     path: '/cont/approve/detail',
      //     query: { id: item.contractId }
      //   })
      // } else {
      this.$router.push({
        path: '/cont/approve/detail',
        query: { id: item.contractId, active: '66' }
      })
      // }
    },
    async handleList() {
      this.loading = true
      const res = await newContract.listContract(this.queryParams)

      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    async getContCount(query) {
      const res = await newContract.getVerifyCount(query)
      if (res.code === 200) {
        if (res.data) {
          this.contCount = res.data
        } else {
          this.contCount = {}
        }
        // this.contCount = res.data
      }
    },
    onLoad() {
      this.handleList()
      this.getContCount()
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    handleClick(tab, event) {
      // if (tab == '0') {
      //   this.queryParams.templateType = null
      //   this.queryParams.payType = null
      //   this.queryParams.contractStatus = 4
      // } else if (tab == '1') {
      //   this.queryParams.templateType = 2
      //   this.queryParams.payType = 1
      //   this.queryParams.contractStatus = 1
      // } else if (tab == '2') {
      //   this.queryParams.templateType = null
      //   this.queryParams.payType = 2
      //   this.queryParams.contractStatus = 3
      // } else
      if (tab == '0') {
        this.queryParams.templateType = null
        this.queryParams.payType = null
        this.queryParams.contractStatus = 6
      } else if (tab == '1') {
        this.queryParams.templateType = null
        this.queryParams.payType = null
        this.queryParams.contractStatus = 7
      }
      this.queryCustList()
    },
    handleAddContract() {
      this.add_show = true
    },
    handleAddContractCancel() {
      this.add_show = false
    },
    // 添加合同
    async addContractBeforeClose() {
      this.add_show = false
      await this.queryCustList()
      // let _this = this;
      // // if (type === "confirm") {
      // //   try {
      //     // await this.$refs["form"].validate();
      //     addContract(form).then((response) => {
      //       if(response.code == 200){
      //         Toast.success("添加成功");
      //         _this.add_show = false;
      //       }else{
      //         Toast.fail("添加失败:"+response.msg);
      //       }
      //     });
      //     setTimeout(() => {
      //       _this.queryContractList();
      //     },500)
      //     // done();
      //   // } catch (err) {
      //   //   return done(false);
      //   // }
      // //   return done(false);
      // // } else {
      // //   return done();
      // // }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
</style>
